import React from 'react';
import styles from './beta-icon.module.scss';

const BetaIcon = () => {
    return (<span className={styles.cgBetaIcon}>BETA</span>)
}

export default BetaIcon;